
import React from "react";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Edit, Trash2, Clock, BarChart2, Power } from "lucide-react";
import { ChannelBadge } from "./message-utils/ChannelBadges";
import { AutomatedMessage } from "./message-utils/types";
import { getFormattedSendTime } from "./message-utils/helpers";

interface MessageItemProps {
  message: AutomatedMessage;
  onEdit: (message: AutomatedMessage) => void;
  onDelete: (id: string) => void;
  onOpenAnalytics: (message: AutomatedMessage) => void;
  onToggleActive: (id: string) => void;
  isModuleEnabled?: boolean;
}

const MessageItem = ({ 
  message, 
  onEdit, 
  onDelete, 
  onOpenAnalytics, 
  onToggleActive, 
  isModuleEnabled = true 
}: MessageItemProps) => {
  return (
    <div className={`p-4 border rounded-md flex justify-between items-start transition-opacity ${
      !message.isActive ? 'opacity-50' : ''
    }`}>
      <div className="flex-1">
        <div className="flex items-center text-sm font-medium mb-1">
          <Clock className="mr-2 h-4 w-4" />
          <span>{getFormattedSendTime(message.sendTime)}</span>
          {!message.isActive && (
            <span className="ml-2 px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded-full">
              Inativa
            </span>
          )}
        </div>
        <p className="text-sm text-gray-600 mb-2">{message.message}</p>
        
        {/* Channel badges */}
        <div className="flex flex-wrap gap-1.5">
          {message.channels.map(channel => (
            <span key={channel}><ChannelBadge channel={channel} /></span>
          ))}
        </div>
      </div>
      <div className="flex items-center space-x-2 ml-4">
        <div className="flex items-center space-x-2">
          <Power className={`h-4 w-4 ${message.isActive ? 'text-green-600' : 'text-gray-400'}`} />
          <Switch
            checked={message.isActive}
            onCheckedChange={() => onToggleActive(message.id)}
            disabled={!isModuleEnabled}
          />
        </div>
        <Button variant="outline" size="sm" onClick={() => onOpenAnalytics(message)}>
          <BarChart2 className="h-4 w-4" />
        </Button>
        <Button variant="outline" size="sm" onClick={() => onEdit(message)} disabled={!isModuleEnabled}>
          <Edit className="h-4 w-4" />
        </Button>
        <Button variant="outline" size="sm" onClick={() => onDelete(message.id)} disabled={!isModuleEnabled}>
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default MessageItem;
